import { RepositoryService } from 'src/app/baseServices/repository.service';
import { SyncService } from 'src/app/baseServices/sync.service';
import { SyncActionTypeId } from 'src/app/constant/sync-action-constants/sync-action-types.constants';
import { ActivityService } from 'src/app/services/activity.service';
import { ActivityLogService } from 'src/app/services/activityLog.service';
import { EventBusService } from 'src/app/services/event-bus.service';
import { TimeRecordService } from 'src/app/services/timeRecord.service';
import { HttpMethod } from 'src/app/utils/http/http-method';
import { CompletedSyncAction, SavedSyncAction } from './sync-action-interface';
import { TimeSyncService } from 'src/app/services/time-sync.service';
import { OdometerReadingService } from 'src/app/services/odometer-reading.service';
import { OdometerReadingMedia } from 'src/app/entities/OdometerReadingMedia';
import { OdometerReadingMediaService } from 'src/app/services/odometer-reading-media.service';

/** Enum for service names */
export enum ServiceNames {
  ActivityLogService = 'activityLogService',
  ActivityService = 'activityService',
  TimeRecordService = 'timeRecordService',
  RepositoryService = 'repositoryService',
  EventBusService = 'eventBusService',
  TimeSyncService = 'timeSyncService',
  OdometerReadingService = 'odometerReadingService',
  OdometerReadingMediaService = 'odometerReadingMediaService',
}

/** Interface for service injections */
export interface ServiceInjections {
  activityLogService?: ActivityLogService;
  activityService?: ActivityService;
  timeRecordService?: TimeRecordService;
  repositoryService?: RepositoryService;
  syncService?: SyncService;
  eventBusService?: EventBusService;
  timeSyncService?: TimeSyncService;
  odometerReadingService?: OdometerReadingService;
  odometerReadingMediaService?: OdometerReadingMediaService;
}

/**
 * Interface for a sync action type.
 * @template T - A type that extends SyncActionTypeId.
 */
export interface SyncActionType<T extends SyncActionTypeId> {
  /** The ID of the sync action type. */
  id: T;

  /** A description of the sync action type. */
  description: string;

  /** The URL to be used for the sync action. */
  url: string;

  /** The HTTP method to be used for the sync action. */
  method: HttpMethod;

  /** The timeout for each attempt of the sync action, in seconds. */
  attemptTimeout: number;

  /** The maximum number of attempts for the sync action. Note that if the server returns a bad request error, the sync action will not reattempt. */
  maxAttempts: number;

  /** The services that this sync action's onSuccess and onFailure functions depend on. */
  serviceDependencies: ServiceNames[];

  /**
   * A function to be called prior to the sync action being uploaded.
   * @param serviceInjections - The services that were injected for this sync action.
   */
  doBefore?: (serviceInjections: ServiceInjections, action: SavedSyncAction<T>) => Promise<void>;

  /**
   * A function to be called when the sync action is successful.
   * @param serviceInjections - The services that were injected for this sync action.
   */
  onSuccess: (serviceInjections: ServiceInjections, action: CompletedSyncAction<T>) => Promise<void>;

  /**
   * A function to be called when the sync action fails.
   * @param serviceInjections - The services that were injected for this sync action.
   */
  onFailure: (serviceInjections: ServiceInjections, action: CompletedSyncAction<T>) => Promise<void>;
}
